const styles = () => ({

	root: {
		textAlign: 'end',
	},

});

export default styles;